import React from 'react';
import '../styles/Reports.scss';

const SubMinWarning = ({ results }) => {
  if (!results || !results.some(r => r.sub_minimum_met === false)) return null;

  return (
    <div className="reports-submin-warning">
      ⚠ One or more sub-minimum thresholds not met — overall scorecard level will be discounted by one level.
    </div>
  );
};

export default SubMinWarning;
